import React from "react";
import { cn } from "@/lib/utils";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Optional size of the icon (width and height)
   */
  size?: number;
  /**
   * Optional color of the icon
   */
  color?: string;
  /**
   * Optional stroke width of the icon
   */
  strokeWidth?: number;
  /**
   * Optional className for additional styling
   */
  className?: string;
  /**
   * Optional title for accessibility
   */
  title?: string;

  viewBox?: string;
}

/**
 * Base Icon component that all other icon components will extend
 */
export const Icon: React.FC<IconProps> = ({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className,
  children,
  title,
  viewBox = "0 0 24 24",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("inline-block", className)}
      aria-hidden={title ? "false" : "true"}
      {...props}
    >
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
};

export default Icon;
